export const DEFAULT_SEARCH_DEBOUNCE = 500;

export const SKILL_SOURCE_CUSTOM_ONTOLOGY = 'custom-ontology';

export const PROFICIENCY_STAR_COLOR_FILLED = '#FFA726';
export const PROFICIENCY_STAR_COLOR_EMPTY = '#E0E0E0';

export type ProficiencyLevel = 'Beginner' | 'Experience' | 'Expert' | 'SuperExpert';

export const DEFAULT_PROFICIENCY_LEVELS: readonly ProficiencyLevel[] = ['Beginner', 'Experience', 'Expert'];
